(function (scope) {
  'use strict';
  var labels = {
    ar: { title: 'الإشعارات', close: 'إغلاق', all: 'تحديد الكل كمقروء', refresh: 'تحديث', empty: 'لا توجد إشعارات حاليًا', offers: 'العروض والأخبار', orders: 'تحديثات الطلبات', login: 'سجّل الدخول لعرض إشعارات طلباتك', loading: 'جارٍ تحميل الإشعارات…', error: 'تعذّر تحديث بعض الإشعارات. حاول مجددًا.', order: 'الطلب ', unread: 'غير مقروء' },
    en: { title: 'Notifications', close: 'Close', all: 'Mark all as read', refresh: 'Refresh', empty: 'No notifications yet', offers: 'Offers and news', orders: 'Order updates', login: 'Sign in to see your order updates', loading: 'Loading notifications…', error: 'Some notifications could not be updated. Please retry.', order: 'Order ', unread: 'Unread' }
  };
  var statuses = {
    awaiting_confirmation: ['بانتظار تأكيد الطلب', 'Awaiting confirmation'], confirmed: ['بانتظار الشحن', 'Awaiting shipment'],
    ready: ['جاري التوصيل', 'Delivery in progress'], shipped: ['تم الشحن', 'Shipped'], in_transit: ['الطلب مع مندوب التوصيل', 'With the delivery courier'],
    delivered: ['تم التسليم', 'Delivered'], cancelled: ['تم إلغاء الطلب', 'Cancelled'], partially_delivered: ['تم تسليم جزء من الطلب', 'Partially delivered'],
    partially_shipped: ['تم شحن جزء من الطلب', 'Partially shipped'], returned: ['تم إرجاع الطلب', 'Returned'], reserved: ['بانتظار الشحن', 'Awaiting shipment']
  };
  function safeUrl(value, base, image) {
    if (typeof value === 'string') value = value.trim();
    if (typeof value !== 'string' || !value.trim() || /^[\\/]{2}|[\u0000-\u001f\\]/.test(value)) return null;
    try {
      var url = new URL(value, base);
      var hosts = image ? ['rwady.com.iq', 'www.rwady.com.iq', 'rwady.com', 'www.rwady.com', 'cdn.shopify.com'] : ['rwady.com.iq', 'www.rwady.com.iq', 'rwady.com', 'www.rwady.com'];
      return url.protocol === 'https:' && !url.username && !url.password && !url.port && hosts.indexOf(url.hostname) !== -1 ? url.href : null;
    } catch (_) { return null; }
  }
  function publicItems(payload, base, now) {
    var seen = new Set();
    return (Array.isArray(payload && payload.items) ? payload.items : []).slice(0, 50).flatMap(function (row) {
      if (!row || typeof row.id !== 'string' || !row.id || seen.has(row.id) || typeof row.title !== 'string') return [];
      var time = Date.parse(row.published_at), url = safeUrl(row.url, base);
      if (!url || !Number.isFinite(time) || time > now) return [];
      seen.add(row.id);
      return [{ id: 'public:' + row.id + ':' + row.published_at, title: row.title.slice(0, 200), body: String(row.body || '').slice(0, 2000), url: url, image: safeUrl(row.image_url, base, true), time: time, kind: 'public' }];
    });
  }
  function orderLink(accountUrl, orderId, shipmentId) {
    return accountUrl + (accountUrl.indexOf('?') === -1 ? '?' : '&') + 'account_tab=orders&order_id=' + encodeURIComponent(orderId) +
      (shipmentId ? '&shipment_id=' + encodeURIComponent(shipmentId) : '');
  }
  function orderItems(payload, locale, accountUrl, summary) {
    if (!payload || payload.shopify_link_state && payload.shopify_link_state !== 'linked') return [];
    var seen = new Set();
    return (Array.isArray(payload.orders) ? payload.orders : []).slice(0, 50).flatMap(function (order) {
      if (!order || typeof order !== 'object') return [];
      var status = summary ? summary(order) : null;
      status = status || order.tracking_status;
      var id = String(order.id || order.name || '');
      if (!id || seen.has(id)) return [];
      seen.add(id);
      var snapshotTime = order.line_fulfillment && order.line_fulfillment.updated_at;
      var time = Date.parse(snapshotTime || order.processed_at);

      var snapshot = order.line_fulfillment;
      var lineIds = new Set((Array.isArray(order.items) ? order.items : []).map(function (item) { return item && item.line_item_id; }).filter(Boolean));
      var shipmentIds = new Set();
      var shipments = (Array.isArray(snapshot && snapshot.shipments) ? snapshot.shipments : []).slice(0, 50).flatMap(function (shipment) {
        if (!shipment || typeof shipment.id !== 'string' || !shipment.id || shipmentIds.has(shipment.id)) return [];
        var shipmentStatus = shipment.customer_status || shipment.status;
        if (['ready', 'shipped', 'in_transit', 'delivered', 'returned'].indexOf(shipmentStatus) === -1) return [];
        if (!Array.isArray(shipment.items) || !shipment.items.some(function (item) { return item && lineIds.has(item.line_item_id) && Number(item.quantity) > 0; })) return [];
        shipmentIds.add(shipment.id);
        var number = String(shipment.number || '').slice(0, 100);
        var shipmentTitle = (locale === 'ar' ? 'الشحنة' : 'Shipment') + (number ? ' ' + number : '');
        var orderTitle = labels[locale].order + String(order.name || id).slice(0, 100);
        return [{ id: 'shipment:' + id + ':' + shipment.id + ':' + shipmentStatus, title: shipmentTitle + ' — ' + orderTitle,
          body: statuses[shipmentStatus][locale === 'ar' ? 0 : 1], url: orderLink(accountUrl, id, shipment.id), image: null,
          time: Number.isFinite(time) ? time : 0, kind: 'order' }];
      });
      if (shipments.length) return shipments;
      if (!Object.prototype.hasOwnProperty.call(statuses, status)) return [];
      var body = statuses[status][locale === 'ar' ? 0 : 1], countKey = '';
      if (status === 'confirmed' && snapshot && Array.isArray(snapshot.lines) && lineIds.size && !order.has_more_items) {
        var confirmedLines = new Map(snapshot.lines.filter(function (line) { return line && lineIds.has(line.line_item_id); }).map(function (line) { return [line.line_item_id, line]; }));
        if (confirmedLines.size === lineIds.size) {
          var confirmedCount = 0;
          confirmedLines.forEach(function (line) {
            var quantity = Number(line.quantity);
            if (line.availability_confirmed === true && line.availability === 'available' && !line.removal_reason &&
                line.status !== 'cancelled' && line.customer_status !== 'cancelled' && line.status !== 'returned' &&
                Number.isSafeInteger(quantity) && quantity > 0) confirmedCount += quantity;
          });
          if (confirmedCount > 0 && Number.isSafeInteger(confirmedCount)) {
            body += locale === 'ar' ? ' — عدد المنتجات المؤكدة: ' + confirmedCount.toLocaleString('ar-IQ') : ' — Confirmed items: ' + confirmedCount;
            countKey = ':count:' + confirmedCount;
          }
        }
      }
      return [{ id: 'order:' + id + ':' + status + countKey, title: labels[locale].order + String(order.name || id).slice(0, 100), body: body, url: orderLink(accountUrl, id), image: null, time: Number.isFinite(time) ? time : 0, kind: 'order' }];
    });
  }
  function popupCandidates(items, seen, read, now) {
    return items.filter(function (item) {
      return item.kind === 'order' && item.key && !seen.has(item.key) && !read.has(item.key) &&
        Number.isFinite(item.time) && item.time <= now && now - item.time < 86400000;
    }).sort(function (a, b) { return b.time - a.time; }).slice(0, 3);
  }
  var core = { popupCandidates: popupCandidates, safeUrl: safeUrl, publicItems: publicItems, orderItems: orderItems };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (!scope.document) return;
  if (scope.RwadyNotifications) { scope.RwadyNotifications.refresh(); return; }
  var doc = scope.document, locale = doc.documentElement.lang.indexOf('ar') === 0 ? 'ar' : 'en', t = labels[locale];
  var accountUrl = (locale === 'ar' ? '/' : '/en/') + 'pages/my-account';
  var general = [], personal = [], authenticated = false, generation = 0, busy = false, timer, lastLoad = 0;
  var read = new Set(), storageKey = 'rwady-notifications-read-v1';
  try { var saved = JSON.parse(scope.localStorage.getItem(storageKey) || '[]'); if (Array.isArray(saved)) read = new Set(saved.filter(function (v) { return typeof v === 'string' && /^[a-f0-9]{64}$/.test(v); }).slice(-1000)); } catch (_) {}
  function persist() { try { scope.localStorage.setItem(storageKey, JSON.stringify(Array.from(read).slice(-1000))); } catch (_) {} }
  function element(tag, className, text) { var el = doc.createElement(tag); el.className = className || ''; if (text) el.textContent = text; return el; }
  var dialog = element('dialog', 'rwady-notifications-panel');
  dialog.id = 'RwadyNotificationsPanel'; dialog.dir = locale === 'ar' ? 'rtl' : 'ltr'; dialog.setAttribute('aria-labelledby', 'RwadyNotificationsTitle');
  var head = element('div', 'rwady-notifications-head');
  var title = element('h2', '', t.title); title.id = 'RwadyNotificationsTitle'; title.tabIndex = -1; head.appendChild(title);
  var close = element('button', 'rwady-notifications-close', '×'); close.type = 'button'; close.setAttribute('aria-label', t.close); head.appendChild(close); dialog.appendChild(head);
  var actions = element('div', 'rwady-notifications-actions');
  var all = element('button', '', t.all), refresh = element('button', '', t.refresh); all.type = refresh.type = 'button'; actions.append(all, refresh); dialog.appendChild(actions);
  var message = element('p', 'rwady-notifications-message'); message.setAttribute('role', 'status'); dialog.appendChild(message);
  var list = element('div', 'rwady-notifications-list'); dialog.appendChild(list);
  var login = element('a', 'rwady-notifications-login', t.login); login.href = accountUrl; dialog.appendChild(login);
  doc.body.appendChild(dialog);
  var popupSeen = new Set(), popupReady = false;
  var popupStorageKey = 'rwady-notification-popups-v1';
  try {
    var popupSaved = JSON.parse(scope.sessionStorage.getItem(popupStorageKey) || 'null');
    if (Array.isArray(popupSaved)) {
      popupSeen = new Set(popupSaved.filter(function (key) { return typeof key === 'string' && /^[a-f0-9]{64}$/.test(key); }).slice(-1000));
      popupReady = true;
    }
  } catch (_) {}
  var popupRegion = element('div', 'rwady-notification-popups');
  popupRegion.dir = locale === 'ar' ? 'rtl' : 'ltr';
  popupRegion.setAttribute('aria-live', 'polite');
  popupRegion.setAttribute('aria-relevant', 'additions');
  doc.body.appendChild(popupRegion);
  function savePopupSeen() {
    try { scope.sessionStorage.setItem(popupStorageKey, JSON.stringify(Array.from(popupSeen).slice(-1000))); } catch (_) {}
  }
  function showOrderPopups(items) {
    if (doc.hidden || !authenticated) return;
    if (!popupReady) {
      items.forEach(function (item) { if (item.key) popupSeen.add(item.key); });
      popupReady = true;
      savePopupSeen();
      return;
    }
    var candidates = popupCandidates(items, popupSeen, read, Date.now());
    candidates.forEach(function (item) {
      if (popupRegion.children.length >= 3) return;
      popupSeen.add(item.key);
      if (dialog.open) return;
      var popup = element('div', 'rwady-notification-popup');
      var link = element('a', 'rwady-notification-popup__link');
      link.href = item.url;
      link.appendChild(element('strong', '', item.body));
      link.appendChild(element('span', '', item.title));
      link.addEventListener('click', function () { read.add(item.key); persist(); popup.remove(); draw(); });
      var dismiss = element('button', 'rwady-notification-popup__close', '×');
      dismiss.type = 'button'; dismiss.setAttribute('aria-label', t.close);
      dismiss.addEventListener('click', function () { popup.remove(); });
      popup.append(link, dismiss);
      popup.addEventListener('animationend', function (event) { if (!event || event.target === popup) popup.remove(); });
      popupRegion.appendChild(popup);
    });
    savePopupSeen();
  }
  var opener;
  function buttons() { return Array.from(doc.querySelectorAll('[data-rwady-notifications]')); }
  function draw() {
    var items = general.concat(personal).sort(function (a, b) { return b.time - a.time; });
    var unread = items.filter(function (item) { return item.key && !read.has(item.key); }).length;
    buttons().forEach(function (button) {
      button.setAttribute('aria-expanded', String(dialog.open));
      button.setAttribute('aria-controls', dialog.id);
      button.setAttribute('aria-label', t.title + (unread ? ' (' + unread + ')' : ''));
      var badge = button.querySelector('[data-notification-count]'); if (badge) { badge.textContent = unread > 99 ? '99+' : String(unread); badge.hidden = !unread; }
    });
    list.replaceChildren();
    items.forEach(function (item) {
      var unreadItem = item.key && !read.has(item.key);
      var link = element('a', 'rwady-notification' + (unreadItem ? ' is-unread' : '')); link.href = item.url;
      if (item.image) { var img = element('img'); img.src = item.image; img.alt = ''; img.width = img.height = 52; img.loading = 'lazy'; link.appendChild(img); }
      var content = element('div', 'rwady-notification-copy');
      content.appendChild(element('small', '', item.kind === 'order' ? t.orders : t.offers));
      content.appendChild(element('strong', '', item.title)); content.appendChild(element('p', '', item.body));
      if (unreadItem) content.appendChild(element('span', 'rwady-notification-unread', t.unread));
      link.appendChild(content); link.addEventListener('click', function () { if (item.key) { read.add(item.key); persist(); } }); list.appendChild(link);
    });
    if (!items.length && !busy) list.appendChild(element('p', 'rwady-notifications-empty', t.empty));
    login.hidden = authenticated; all.disabled = !unread;
  }
  async function keys(items) {
    if (!scope.crypto || !scope.crypto.subtle) return items;
    return Promise.all(items.map(async function (item) {
      var digest = await scope.crypto.subtle.digest('SHA-256', new TextEncoder().encode(item.id));
      item.key = Array.from(new Uint8Array(digest)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join(''); return item;
    }));
  }
  function clearPersonal() { popupRegion.replaceChildren(); generation++; personal = []; authenticated = false; busy = false; refresh.disabled = false; message.textContent = ''; draw(); }
  async function load(force) {
    if (doc.hidden || busy || !force && Date.now() - lastLoad < 60000) return;
    var current = ++generation; busy = true; message.textContent = t.loading; refresh.disabled = true; lastLoad = Date.now();
    var failed = false;
    var publicRequest = (async function () {
      try {
        var response = await fetch('https://rwady-content-buddy.lovable.app/api/public/notifications/feed?locale=' + locale, { credentials: 'omit', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('FEED_FAILED');
        var items = await keys(publicItems(await response.json(), 'https://rwady.com.iq', Date.now()));
        if (current === generation) general = items;
      } catch (_) { failed = true; if (current === generation) general = []; }
    }());
    var privateRequest = (async function () {
      try {
        if (!scope.RwadyAccountApi) return;
        var api = scope.RwadyAccountApi.createClient({ baseUrl: 'https://account.rwady.com.iq', fetchImpl: function (url, options) { return fetch(url, Object.assign({}, options, { signal: AbortSignal.timeout(15000) })); } });
        var session = await api.session();
        if (current !== generation) return;
        personal = [];
        authenticated = session && session.authenticated === true;
        if (!authenticated) return;
        var payload = await api.profile();
        var items = await keys(orderItems(payload, locale, accountUrl, scope.RwadyAccountApi.orderLineSummary));
        if (current === generation) { personal = items; showOrderPopups(items); }
      } catch (error) { if (current === generation) { personal = []; authenticated = false; popupRegion.replaceChildren(); } if (!error || error.status !== 401) failed = true; }
    }());
    await Promise.all([publicRequest, privateRequest]);
    if (current !== generation) return;
    busy = false; refresh.disabled = false; message.textContent = failed ? t.error : ''; draw();
  }
  doc.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rwady-notifications]'); if (!button) return;
    event.preventDefault(); opener = button;
    if (!dialog.open) { dialog.showModal(); title.focus({ preventScroll: true }); } draw(); load(true);
  });
  close.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close', function () { draw(); if (opener && opener.isConnected) opener.focus({ preventScroll: true }); });
  all.addEventListener('click', function () { general.concat(personal).forEach(function (item) { if (item.key) read.add(item.key); }); persist(); draw(); });
  refresh.addEventListener('click', function () { load(true); });
  doc.addEventListener('rwady:account-logout', clearPersonal);
  doc.addEventListener('rwady:account-avatar-updated', function (event) { if (!event.detail || !event.detail.authenticated) clearPersonal(); else if (event.detail.reason === 'profile') { clearPersonal(); load(true); } });
  doc.addEventListener('visibilitychange', function () { if (doc.hidden) clearPersonal(); else load(true); });
  scope.addEventListener('pagehide', function () { clearTimeout(timer); clearPersonal(); });
  scope.addEventListener('pageshow', function () { clearPersonal(); load(true); schedule(); });
  scope.addEventListener('storage', function (event) { if (event.key === storageKey) { try { read = new Set(JSON.parse(event.newValue || '[]')); draw(); } catch (_) {} } });
  doc.addEventListener('shopify:section:load', draw);
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { load(); schedule(); }, 60000); }
  scope.RwadyNotifications = { refresh: function () { load(true); } }; draw(); load(true); schedule();
}(typeof window !== 'undefined' ? window : globalThis));
